import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import {
  palette,
  radius,
  shadow,
  spacing,
  transition,
  typography,
} from '../../../style-utils/theme';
import { LEGAL_DOCS, legalHref } from '../../legal/legal-docs';
import { SectionHeading, SectionLead } from './account.styled';

/* Every role reaches the policies from here (and from the profile menu, which
   links here). Each opens in the app at /legal/<doc>; the text is the one
   published on lobbero.com, copied by scripts/sync-legal.mjs. */

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
`;

const Item = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding: ${spacing.sm} ${spacing.md};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.surface};
  text-decoration: none;
  transition: ${transition.colors};

  &:hover {
    border-color: ${palette.iris};
    background: ${palette.irisTintSoft};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${shadow.focus};
  }
`;

const Title = styled.span`
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.lagoon};
`;

const Blurb = styled.span`
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  line-height: ${typography.leading.normal};
  color: ${palette.slate};
`;

export const AccountLegal: React.FC = () => (
  <>
    <SectionHeading>Legal &amp; privacy</SectionHeading>
    <SectionLead>
      The terms Lobbero is provided under, and how it handles the information in
      your buildings. The same documents published on lobbero.com.
    </SectionLead>
    <List>
      {LEGAL_DOCS.map(doc => (
        <li key={doc.slug}>
          <Item to={legalHref(doc.slug)}>
            <Title>{doc.title}</Title>
            <Blurb>{doc.description}</Blurb>
          </Item>
        </li>
      ))}
    </List>
  </>
);
